module.exports = __webpack_public_path__ + "static/media/gold-foil-1px.a475ace6.png";